import React, {useRef, useLayoutEffect} from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import {parseSingleChoiceData} from "../../../../utils/ChartsUtils";

function PieChartComponent(props) {
    const chartRef = useRef(null);

    // const [ legendData, setLegendData ] = useState([]);

    function am4themes_bubblyTheme(target) {
        if (target instanceof am4core.ColorSet) {
            target.list = [
                am4core.color("#D2B7F9"),
                am4core.color("#9DE0D8"),
                am4core.color("#FFD166"),
                am4core.color("#FBAC79"),
                am4core.color("#A5D6FA"),
                am4core.color("#9AA5F5"),
                am4core.color("#FCE896"),
                am4core.color("#F2768E"),
                am4core.color("#BCE09D"),
                am4core.color("#C9977D"),
                am4core.color("#C2CBCA"),
            ];
        }
    }

    function updateCurrentChartInfo(chart) {
        let newChartInfo = {
            chartText: props.questionTitle,
            numAnswers: props.answersData.total,
            chart: chart
        };
        props.updateChartInfo && props.updateChartInfo(props.chartIndex, newChartInfo);
    }

    const buildPieChart = (chart) => {
        chart.width = props.chartConfig.width;
        chart.height = props.chartConfig.height;
        chart.data = parseSingleChoiceData(props.answersData);

        let pieSeries = chart.series.push(new am4charts.PieSeries());
        pieSeries.dataFields.value = "noOfAnswers";
        pieSeries.colors.reuse = true;
        pieSeries.dataFields.category = "choiceLabel";
        pieSeries.slices.template.stroke = am4core.color("#fff");
        pieSeries.slices.template.strokeOpacity = 1;
        pieSeries.hiddenState.properties.opacity = 1;
        pieSeries.hiddenState.properties.endAngle = -90;
        pieSeries.hiddenState.properties.startAngle = -90;
        pieSeries.labels.template.maxWidth = 230;
        pieSeries.labels.template.wrap = true;
        chart.radius = am4core.percent(65);
        // 70
        chart.hiddenState.properties.radius = am4core.percent(0);

        // let tmpLegendData = [];
        // chart.events.on("ready", function (event) {
        //     pieSeries.dataItems.each(function (row, i) {
        //         let percent = Math.round(row.values.value.percent * 100) / 100;
        //         let value = row.value;
        //         tmpLegendData.push(percent + "%" + value);
        //     });
        //     setLegendData(tmpLegendData);
        //
        // });
    };


    useLayoutEffect(() => {
        am4core.useTheme(am4themes_bubblyTheme);
        am4core.useTheme(am4themes_animated);
        let x = am4core.create("chart_pie_div_" + props.questionId, am4charts.PieChart);

        buildPieChart(x);

        chartRef.current = x;
        updateCurrentChartInfo(chartRef.current);
        return () => {
            x.dispose();
        };
    }, []);

    useLayoutEffect(() => {
        chartRef.current.width = props.chartConfig.width;
        chartRef.current.height = props.chartConfig.height;
        updateCurrentChartInfo(chartRef.current);
    }, [props.chartConfig]);

    useLayoutEffect( () => {
        if(props.sortingOptions !== null) {
            sortData(props.sortingOptions.option);
        }
        updateCurrentChartInfo(chartRef.current);
    },[props.sortingOptions]);

    function sortData(operation){

        if(operation === 'asc'){
            chartRef.current.data = chartRef.current.data.sort(function (a, b) {
                return b.noOfAnswers - a.noOfAnswers;
            });
        }

        if(operation === 'desc'){
            chartRef.current.data = chartRef.current.data.sort(function (a, b) {
                return a.noOfAnswers - b.noOfAnswers;
            });
        }


        if(operation === 'revert'){
            chartRef.current.data = parseSingleChoiceData(props.answersData);
        }
    }

    return (
        <div className="centered-chart" id={"chart_pie_div_" + props.questionId} style={{width: props.chartConfig.width, height: props.chartConfig.height}}></div>
    );
}

export default PieChartComponent;